import { useState } from "react";
import axios from "axios";
import UploadImage from "./_ImvImagesUpload";
import { host } from "../../../services/host_data";

export default function ImagesUpload({ nreg }) {
    const [images, setImages] = useState(undefined);
    const [imagesNames, setImagesNames] = useState([])

    const handleFileChange = (e) => {
        const files = e.target.files;
        setImages(files);
    };

    const handleSubmitImages = () => {
        if (!nreg) {
            window.alert('Insira um Numero de Registro Antes de Enviar as Imagens')
        } else {
            UploadImage({nreg, images})
        }
    }

    return <>
        <div id="added_images" className="border rounded-t-lg px-10 py-5">
            <h1 className="text-xl text-center text-white mb-5"> Imagens Selecionadas: </h1>
            {/* Mostrar as imagens selecionadas */}
            <article className="grid gap-5 grid-cols-4">
                {images ? Array.from(images).map((file, index) => (
                    <img className="border border-white aspect-video rounded-lg cursor-pointer hover:brightness-50"
                        key={index} src={URL.createObjectURL(file)} alt={`Imagem ${index}`} />
                )) : 
                    undefined }
            </article>
        </div>
        <div className="border-l border-r p-10 cursor-pointer hover:bg-[#fff4]">
            <figure className="fill-[#fff4] w-3/6 mx-auto p-5">
                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="FilterIcon" aria-label="fontSize medium">
                    <path d="m15.96 10.29-2.75 3.54-1.96-2.36L8.5 15h11zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2m0 16H7V3h14z">
                    </path>
                </svg>
            </figure>

            <div className="" >
                <input type="file" multiple={true} onChange={handleFileChange} />
                <p className="text-white text-center">Arraste e solte algumas imagens aqui, ou clique para selecionar.</p>
            </div>
        </div>
        <div className="text-xl text-white text-center w-full p-5 cursor-pointer bg-[green] hover:bg-[#45ac45] rounded-b-lg"
            onClick={() => handleSubmitImages()}
        >
            Enviar Imagens
        </div>
    </>
}